import { createSelector } from "@reduxjs/toolkit"
import type { Address } from "viem"
import type { EnabledVaultsAccountInfo, EnabledVaultsInfo } from "../types"

export const reduceCurrentAccountVaultAccountInfo = createSelector(
  [
    (accountStatus: EnabledVaultsInfo[]) => accountStatus,
    (_, currentAccount?: Address) => currentAccount,
  ],
  (accountStatus, currentAccount) => {
    if (!accountStatus || !currentAccount)
      return new Map<Address, EnabledVaultsAccountInfo>()

    const onlyCurrentAccount = accountStatus.filter(
      (account) =>
        account?.evcAccountInfo.account.toLowerCase() ===
        currentAccount.toLowerCase(),
    )
    const currentAccountVaultAccountInfo = onlyCurrentAccount.map(
      (account) => account?.vaultAccountInfo,
    )
    const vaultAccountInfoMap = new Map<Address, EnabledVaultsAccountInfo>()
    currentAccountVaultAccountInfo.forEach((vaultAccountInfoArray) => {
      vaultAccountInfoArray?.forEach((vaultAccountInfo) => {
        vaultAccountInfoMap.set(vaultAccountInfo.vault, vaultAccountInfo)
      })
    })

    return vaultAccountInfoMap
  },
)
